<script>
import { MODAL, RELOAD } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import { apiCrmTranscricoes } from '@modules/crm/api/apiCrmTranscricoes'
import TranscriptParticipants from '@modules/crm/components/transcript-participants/transcript-participants.vue'

export default {
  name: 'DetailTabParticipantes',
  components: { TranscriptParticipants },
  props: {
    transcriptId: { type: [String, Number], default: null },
    participants: { type: Array, default: () => [] },
  },
  methods: {
    // Edição via modal dedicado (TranscriptParticipantsModal), aberto por
    // GlobalBus — o modal salva e dispara TRANSCRIPT_RELOAD p/ atualizar o detalhe.
    openModal() {
      GlobalBus.$emit(MODAL.TRANSCRIPT_PARTICIPANTS, {
        id: this.transcriptId,
        participants: this.participants,
      })
    },
    // Abre o modal já com um campo novo focado (bloco "Adicionar participante").
    openModalAdd() {
      GlobalBus.$emit(MODAL.TRANSCRIPT_PARTICIPANTS, {
        id: this.transcriptId,
        participants: this.participants,
        addNew: true,
      })
    },
    // Remoção direta de um participante, com confirmação (showModal danger v2).
    confirmRemove({ index } = {}) {
      this.$showModal({
        type: 'danger',
        v2: true,
        center: true,
        title: 'Remover participante',
        text: 'Deseja remover este participante? Essa ação não pode ser desfeita.',
        buttons: [
          { text: 'Cancelar', action: () => {} },
          { text: 'Remover', action: () => this.removeParticipant(index) },
        ],
      })
    },
    async removeParticipant(index) {
      const participants = this.participants
        .map((p) => ({
          nome: (p && (p.nome || p.name)) || '',
          email: (p && (p.email || p.e_mail)) || null,
        }))
        .filter((p, i) => p.nome && i !== index)

      const r = await apiCrmTranscricoes.atualizar({
        id: this.transcriptId,
        participants,
      })
      this.$showSnack(r)
      if (r && r.status === 200) {
        GlobalBus.$emit(RELOAD.TRANSCRIPT)
      }
    },
  },
}
</script>

<template>
  <TranscriptParticipants
    :participants="participants"
    editable
    @edit="openModal"
    @add="openModalAdd"
    @remove="confirmRemove"
  />
</template>
